import { FetchType } from '@spotify-internal/remote-config-core';
import { getLogger } from '@spotify-internal/remote-config-common';
export const MIN_BACKGROUND_FETCH_INTERVAL = 1000 * 60 * 10;
const DEFAULT_BACKGROUND_FETCH_INTERVAL = 1000 * 60 * 60;
let currentInterval;
export const backgroundFetchMiddleware = (next) => ({ backgroundFetchInterval = DEFAULT_BACKGROUND_FETCH_INTERVAL, }) => {
    const logger = getLogger('middleware:background-fetch');
    if (backgroundFetchInterval < MIN_BACKGROUND_FETCH_INTERVAL) {
        throw new Error(`backgroundFetchInterval of ${backgroundFetchInterval} is less than the allowed minimum of ${MIN_BACKGROUND_FETCH_INTERVAL}`);
    }
    return (req) => onFinally(next(req), () => {
        updateInterval(() => {
            next(Object.assign(Object.assign({}, req), { fetchType: FetchType.BACKGROUND_SYNC })).catch(error => {
                logger.warn('Background fetch failed', error);
            });
        }, backgroundFetchInterval);
    });
};
function onFinally(promise, callback) {
    return promise.then(value => {
        callback();
        return value;
    }, err => {
        callback();
        throw err;
    });
}
function updateInterval(callb, interval) {
    clearInterval(currentInterval);
    currentInterval = setInterval(callb, interval);
}
//# sourceMappingURL=background-fetch.js.map